import React, { useContext } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Maps from './components/maps/Maps'
// import ScrollToTop from './components/scrolltotop/ScrollToTop'
import { AuthContext } from './contexts/AuthContext'
import CartContextProvider from './contexts/CartContext'
import CategoryContextProvider from './contexts/CategoryContext'
import ProductContextProvider from './contexts/ProductContext'
import ErrorPage from './pages/errorpage/ErrorPage'
import Home from './pages/homepage/Home'
import Order from './pages/order/Order'
import ProductsPage from './pages/productspage/ProductsPage'
import Provider from './pages/provider/Provider'
import ResetPassword from './pages/resetPassword/ResetPassword'
import Service from './pages/service/Service'
import Services from './pages/services/Services'
import ThankyouMessage from './pages/thankyou-message-page/ThankyouMessage'
import VerifyEmail from './pages/verify_email/VerifyEmail'
import Orders from './pages/orders/Orders'
import Profile from './pages/profile/Profile'
import DeliveryLocation from './pages/delivery_location/DeliveryLocation'
import ServicesContextProvider from './contexts/ServicesContext'
import VerifyBooking from './pages/verifyBooking/VerifyBooking'
import VerifyProductsPurchase from './pages/verifyProductsPurchase/VerifyProductsPurchase'
import ServiceOrders from './pages/service_orders/ServiceOrders'
import ServiceBooking from './pages/service_booking/ServiceBooking'
import SearchProduct from './pages/search_product/SearchProduct'
import FavouriteContextProvider from './contexts/FavouriteContext'
import TermsAndConditions from './pages/terms_and_conditions/TermsAndConditions'
import CovidTerms from './pages/terms_and_conditions/CovidTerms'
import PaymentPolicy from './pages/terms_and_conditions/PaymentPolicy'
import DataPolicy from './pages/terms_and_conditions/DataPolicy'

function AppRouter() {
    const { authState } = useContext(AuthContext);

    return (
                <CategoryContextProvider>
                    <ServicesContextProvider>
                        <ProductContextProvider>
                            <CartContextProvider>
                                <FavouriteContextProvider>
                                    <Routes>
                                        <Route exact path="/" element={<Home/>} />
                                        <Route path='/products' element={<ProductsPage/>}/>
                                        <Route path="/services" element={<Services />} />
                                        <Route path="/service" element={<Service />} />
                                        <Route path='/provider' element={<Provider />} />
                                        <Route path="/reset-password" element={<ResetPassword />} />
                                        <Route path="/verify-email" element={<VerifyEmail />} />
                                        <Route path="/error" element={<ErrorPage />} />
                                        <Route path="/thankyou-message" element={<ThankyouMessage />} />
                                        <Route path='/search' element={<SearchProduct />} />
                                        <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
                                        <Route path='/covid-guidelines' element={<CovidTerms /> } />
                                        <Route path='/payment-cancelation-refund-policy' element={<PaymentPolicy />} />
                                        <Route path='/data-policy' element={<DataPolicy />} />
                                        
                                        {
                                            authState ? (
                                                <React.Fragment>
                                                    <Route path='/delivery-location' element={<DeliveryLocation/>} />
                                                    <Route path='/order' element={<Order />} />
                                                    <Route path="/orders" element={<Orders />} />
                                                    <Route path="/profile" element={<Profile />} />
                                                    <Route path="/verify-booking" element={<VerifyBooking />} />
                                                    <Route path='/verify-product-purchase' element={<VerifyProductsPurchase /> } />
                                                    <Route path='/service-bookings' element={<ServiceOrders />} />
                                                    <Route path='/service-booking' element={<ServiceBooking />} />
                                                </React.Fragment>
                                            ) : null
                                        }
                                    </Routes>
                                </FavouriteContextProvider>
                                
                            </CartContextProvider>
                        </ProductContextProvider>
                    </ServicesContextProvider>
                </CategoryContextProvider>
    )
}

export default AppRouter
